// extracted by mini-css-extract-plugin
module.exports = {"monetaryValue":"_dfd69e8","buttonsContainer":"_a858425"};